import React from 'react';
export function Footer() {
  return <footer className="w-full py-12 px-6 md:px-12 mt-24 border-t border-gray-100" data-id="element-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 font-sans" data-id="element-13">
        <p data-id="element-14">&copy; 2026 Cosmiclevel. All rights reserved.</p>
        <p className="mt-2 md:mt-0" data-id="element-15">London</p>
      </div>
    </footer>;
}